import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  accessToken: string | null;
  email: string | null;
  role: string | null;
  worldIds: string[];
  setToken: (access: string) => void;
  setUserInfo: (email: string, role: string, worldIds: string[]) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      email: null,
      role: null,
      worldIds: [],

      setToken: (access) => set({ accessToken: access }),
      setUserInfo: (email, role, worldIds) => set({ email, role, worldIds }),
      logout: () => set({ accessToken: null, email: null, role: null, worldIds: [] }),
    }),
    { name: 'ukfms-auth' },
  ),
);
